import type { Contract } from '@definitions/types/symfonyTypes'

import { isContractForTheme } from './isContractForTheme'
import { isContractValid } from './isContractValid'

/** Filters contracts by time-validity, standard flag, and theme affiliation, then sorts by priority descending. */
export function getFilteredContracts(
  contracts: Contract[],
  themeKey: string
): Contract[] {
  return contracts
    .filter(
      (contract) =>
        contract.standard &&
        isContractForTheme(contract, themeKey) &&
        isContractValid(contract)
    )
    .sort((a, b) => b.priority - a.priority)
}
